<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clip-path="url(#clip0_3744_8379)">
      <path d="M23 2H1V18H10V20H8V22H16V20H14V18H23V2ZM21 16H3V4H21V16Z" fill="#323232" />
    </g>
    <defs>
      <clipPath id="clip0_3744_8379">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
